const JobsModule = {
  components: {
    Adsense,
  },
  template: `
      <div class="jobs">      
        <Adsense unit="3423209573" />
      	<router-view class="uk-margin-xlarge-bottom"></router-view>
      </div>
	`,
};
